import {ITEMS_PER_PAGE} from "constants/general";

export const INITIAL_SCRAPE_TASK_BATCH_STARTS_ITEMS_PER_PAGE = "25";

export const initialScrapeTaskBatchStartsFields = {
    name: "name",
    created: "_created"
};

export const INITIAL_SCRAPE_TASK_BATCH_STARTS_FILTER_OPTIONS = {
    offset: "0",
    limit: ITEMS_PER_PAGE,
    sort_field: "_created",
    sort_direction: "desc"
};